<template>
    <v-container v-if="permitted == false && permitted != null" class="pt-0" fluid>
      <v-dialog v-model="permitted_dialog" max-width="400px">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-shield-lock-outline</v-icon>Security Error</div>
              <p>{{message}}</p>
              <v-progress-circular
                :size="70"
                :width="2"
                :value="100"
                color="error"
                class="mb-4 mr-4"
              >
                <v-icon color="red" x-large>mdi-exclamation-thick</v-icon>
              </v-progress-circular>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
    <v-container v-else v-show="permitted != null" class="pt-0" fluid>
      <v-snackbar
        :value="showMessage()"
        multi-line
        color="#686868"
        top

      >
        {{message}}
      </v-snackbar>

      <v-dialog persistent v-model="BlockingViolation" max-width="400px">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <div class="title font-weight-light pt-2"><v-icon class="mr-1">mdi-information-outline</v-icon>Blocking Value Violation</div>
              <p>Due to the Blocking Value set on the Client, the specified amount cannot be captured</p>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="text-right mb-4">
              <v-btn class="white--text mr-3" small color="#2A353D" @click="BlockingViolation = false">
                ok
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card flat >
      <v-toolbar dense flat color="#2A353D">
        <v-toolbar-title class="white--text subtitle-1 font-weight-normal">Unit Trust Fund Defination</v-toolbar-title>
        <v-spacer/>
        <v-btn fab x-small outlined color="#81DBF6" class="mr-1" v-if="edit == true || create == true" @click="view = false; closeCreate(); closeEdit()"><v-icon>mdi-chevron-left</v-icon></v-btn>
        <v-btn fab x-small outlined color="#81DBF6" @click="$router.push('/Home')"><v-icon>mdi-close</v-icon></v-btn>  </v-toolbar>
      </v-card>

    <!-- ********************************************************************************************CREATE**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->

      <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="create">
        <v-card class="pt-3 mt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pt-3 pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D"
                v-model="UnitTrust.def.ShortName"
                label="Fund Short Name"
                required :error-messages="BNerrors"
                placeholder="----"
                :rules="[
                  v => !!v || 'field is required',
                  v => (v && v.length <= 10) || 'field must be less than 10 characters'
                ]"
              ></v-text-field>
            </v-col>
            <v-col class="pt-3 pb-0">
              <v-text-field
                v-model="UnitTrust.def.Description"
                label="Full Description"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0" cols="3">
              <v-checkbox hide-details class="mb-4" light v-model="UnitTrust.def.IsAssetInvestment" label="Is Asset Investment?"></v-checkbox>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.PortfolioClientId"
                :items="UnderlyingPortfolios"
                item-text="AccountName"
                item-value="AccountID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Underlying Portfolio"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.CurrencyId"
                :items="allCurrencies"
                item-text="CurrencyName"
                item-value="CurrencyID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Reporting Currency"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-card outlined class="mt-0 mb-5">
                <v-data-table
                  dense
                  :headers="asset_classes_headers"
                  :fixed-header="true"
                  :height="179"
                  :items="UnitTrust.AssetClasses"
                  disable-pagination
                  hide-default-footer
                  class="elevation-0 mt-3 section"
                >
                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="black--text caption font-weight-normal">Associated Asset Classes</v-toolbar-title>
                      <v-spacer/>
                      <v-btn @click="NewAssetClass(UnitTrust.AssetClasses)" class="text-right" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.AssetTypeId="{ item }">
                    <v-select
                      :menu-props="{ top: true, offsetY: true }"
                      light dense flat solo class="Account ma-0 pa-0 py-2"
                      v-model="item.AssetTypeId"
                      hide-details
                      :items="UnderlyingAssets"
                      item-text="AssetName"
                      item-value="AssetTypeId"
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-select>
                  </template>

                  <template v-slot:item.Narration="{ item }">
                    <v-text-field
                      class="table-text-field py-2"
                      v-model="item.Narration"
                      light dense flat solo
                      color="#2A353D"
                      hide-details
                      :rules="TextFieldRules"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="removeAssetClass(item, UnitTrust.AssetClasses)">mdi-close</v-icon>
                  </template>

                </v-data-table>
              </v-card>

              <v-row>
                <v-col class="py-0">
                  <v-select
                    outlined dense
                    v-model="UnitTrust.def.FundClass"
                    :items="Classes"
                    item-text="FundClassName"
                    item-value="FundClassId"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Fund Class"
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.LoyalityRate"
                    label="Loyalty Points accumulation rate"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.MaxNoOfUnits"
                    label="Max No. of units"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.MinInvestPeriodValue"
                    label="Min. Investment Period"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                v-model="UnitTrust.def.MaxNoOfWithdrawals"
                label="Max No. of withdrawals per redemption period"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
            <v-col class="py-0">
              <v-card outlined>
                <v-data-table
                  dense
                  :headers="charges_headers"
                  :fixed-header="true"
                  :height="179"
                  :items="UnitTrust.FundCharges"
                  disable-pagination
                  hide-default-footer
                  class="elevation-0 mt-3 section"
                >
                  <template v-slot:top>
                    <v-toolbar dense flat>
                      <v-toolbar-title class="black--text caption font-weight-normal">Fund Charges</v-toolbar-title>
                      <v-spacer/>
                      <v-btn @click="NewFundCharge(UnitTrust.FundCharges)" class="text-right" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.TransactionChargeId="{ item }">
                    <v-select
                      :menu-props="{ top: true, offsetY: true }"
                      light dense flat solo class="ma-0 pa-0 py-2"
                      v-model="item.TransactionChargeId"
                      hide-details
                      :items="Charges"
                      item-text="TransactionCharge"
                      item-value="TransactionChargeID"
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-select>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon small @click="removeFundCharge(item, UnitTrust.FundCharges)">mdi-close</v-icon>
                  </template>

                </v-data-table>
              </v-card>

              <v-checkbox hide-details class="pt-3" light v-model="UnitTrust.def.LoyalityParticipant" label="Fund activated for loyalty participation?"></v-checkbox>

              <v-row class="mt-7">
                <v-col class="py-0">
                  <v-select
                    outlined dense
                    v-model="UnitTrust.def.MinInvestPeriod"
                    :items="InvestmentPeriods"
                    item-text="PeriodName"
                    item-value="PeriodID"
                    placeholder="----"
                    :rules="TextFieldRules"
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.MinInvestAmount"
                    label="Min. Investment Amount"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                v-model="UnitTrust.def.RedemptionPeriod"
                label="Redemption Period (days)"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4 my-0"></v-divider>
          <span class="grey--text subtitle-1 font-weight-normal ml-4 mt-0">Unit Price Details</span>

          <v-row class="ml-1 mr-1 mt-3">
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.PurchaseUnitPrice"
                :items="PriceQuotations"
                label="Purchase Unit Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.FundPriceCalculation"
                :items="PriceCalculations"
                label="Price Calculation"
                item-text="Value"
                item-value="ID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-text-field
                v-model="UnitTrust.def.FundParValue"
                label="Fund Par Value"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.SellingUnitPrice"
                :items="PriceQuotations"
                label="Selling Unit Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.PrePostPriced"
                :items="Pricing"
                label="Pre/Post Priced"
                item-text="Value"
                item-value="ID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense
                v-model="UnitTrust.def.ValuePrice"
                :items="PriceQuotations"
                label="Unit Holder Value Determining Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-divider class="my-0"></v-divider>
              <span class="grey--text subtitle-1 font-weight-normal mt-0">Spread Calculation</span>

              <v-row class="mt-6">
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.BidSpread"
                    label="Bid (%)"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="UnitTrust.def.OfferSpread"
                    label="Offer (%)"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-0">
              <v-textarea
                outlined
                v-model="UnitTrust.def.Notes"
                name="input-7-4"
                label="Notes"
                rows="3"
                value="....................."
              ></v-textarea>

              <div class="text-right mb-4 mt-4">
                <v-btn class="white--text mr-4" small color="#2A353D" @click="closeCreate()">close</v-btn>
                <v-btn class="white--text" small color="#2A353D" :disabled="!valid || loading == true" @click="createNew()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  submit
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-form>

    <!-- ********************************************************************************************EDIT**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->

      <v-form flat color="#ffffff00" ref="form" v-model="valid" lazy-validation v-if="edit" >
        <span class="d-flex flex-row mt-2">
          <span class="grey--text caption font-weight-normal">REFERENCE: <span class="subtitle-2">{{currentUnitTrust.DealNumber}}</span></span>
          <v-spacer/>
          <span class="mr-2 grey--text caption font-weight-normal">Maker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentUnitTrust.MakerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span v-if="currentUnitTrust.CheckerID != 0" class="mx-2 grey--text caption font-weight-normal">Checker: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentUnitTrust.CheckerID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
          <span class="ml-2 grey--text caption font-weight-normal">Last User: <span class="subtitle-2">{{allUsers.filter(u => u.SecurityUserID == currentUnitTrust.LastUserID).map(u => u.FullName)[0].toUpperCase()}}</span></span>
        </span>
        <v-card class="pt-3 mt-3" elevation="12">
          <v-row class="ml-1 mr-1">
            <v-col class="pt-3 pb-0">
              <v-text-field
                light dense outlined
                color="#2A353D" :readonly="view"
                v-model="currentUnitTrust.ShortName"
                label="Fund Short Name"
                required :error-messages="BNerrors"
                placeholder="----"
                :rules="[
                  v => !!v || 'field is required',
                  v => (v && v.length <= 10) || 'field must be less than 10 characters'
                ]"
              ></v-text-field>
            </v-col>
            <v-col class="pt-3 pb-0">
              <v-text-field
                v-model="currentUnitTrust.Description"
                label="Full Description"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs" :readonly="view"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0" cols="3">
              <v-checkbox hide-details :readonly="view" class="mb-4" light v-model="currentUnitTrust.IsAssetInvestment" label="Is Asset Investment?"></v-checkbox>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.PortfolioClientId"
                :items="UnderlyingPortfolios"
                item-text="AccountName"
                item-value="AccountID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Underlying Portfolio"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.CurrencyId"
                :items="allCurrencies"
                item-text="CurrencyName"
                item-value="CurrencyID"
                placeholder="----"
                :rules="TextFieldRules"
                label="Reporting Currency"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-card outlined class="mt-0 mb-5">
                <v-data-table
                  dense
                  :headers="asset_classes_headers"
                  :fixed-header="true"
                  :height="179"
                  :items="currentUnitTrust.asset_classes"
                  disable-pagination
                  hide-default-footer
                  class="elevation-0 mt-3 section"
                >
                  <template v-slot:top >
                    <v-toolbar dense flat>
                      <v-toolbar-title class="black--text caption font-weight-normal">Associated Asset Classes</v-toolbar-title>
                      <v-spacer/>
                      <v-btn :disabled="view" @click="NewAssetClass(currentUnitTrust.asset_classes)" class="text-right" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.AssetTypeId="{ item }">
                    <v-select
                      :menu-props="{ top: true, offsetY: true }"
                      light dense flat solo class="Account ma-0 pa-0 py-2"
                      v-model="item.AssetTypeId"
                      hide-details :readonly="view"
                      :items="UnderlyingAssets"
                      item-text="AssetName"
                      item-value="AssetTypeId"
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-select>
                  </template>

                  <template v-slot:item.Narration="{ item }">
                    <v-text-field
                      class="table-text-field py-2"
                      v-model="item.Narration"
                      light dense flat solo
                      color="#2A353D"
                      hide-details :readonly="view"
                      :rules="TextFieldRules"
                    ></v-text-field>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon :disabled="view" small @click="removeAssetClass(item, currentUnitTrust.asset_classes)">mdi-close</v-icon>
                  </template>

                </v-data-table>
              </v-card>

              <v-row>
                <v-col class="py-0">
                  <v-select
                    outlined dense :readonly="view"
                    v-model="currentUnitTrust.FundClass"
                    :items="Classes"
                    item-text="FundClassName"
                    item-value="FundClassId"
                    placeholder="----"
                    :rules="TextFieldRules"
                    label="Fund Class"
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.LoyalityRate"
                    label="Loyalty Points accumulation rate"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.MaxNoOfUnits"
                    label="Max No. of units"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.MinInvestPeriodValue"
                    label="Min. Investment Period"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                v-model="currentUnitTrust.MaxNoOfWithdrawals"
                label="Max No. of withdrawals per redemption period"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs" :readonly="view"
                v-on="on"
              ></v-text-field>
            </v-col>
            <v-col class="py-0">
              <v-card outlined>
                <v-data-table
                  dense
                  :headers="charges_headers"
                  :fixed-header="true"
                  :height="179"
                  :items="currentUnitTrust.charges"
                  disable-pagination
                  hide-default-footer
                  class="elevation-0 mt-3 section"
                >
                  <template v-slot:top>
                    <v-toolbar dense flat>
                      <v-toolbar-title class="black--text caption font-weight-normal">Fund Charges</v-toolbar-title>
                      <v-spacer/>
                      <v-btn :disabled="view" @click="NewFundCharge(currentUnitTrust.charges)" class="text-right" x-small dark outlined fab color="#2A353D">
                        <v-icon small >mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </template>

                  <template v-slot:item.TransactionChargeId="{ item }">
                    <v-select
                      :menu-props="{ top: true, offsetY: true }"
                      light dense flat solo class="ma-0 pa-0 py-2"
                      v-model="item.TransactionChargeId"
                      hide-details :readonly="view"
                      :items="Charges"
                      item-text="TransactionCharge"
                      item-value="TransactionChargeID"
                      placeholder="----"
                      :rules="TextFieldRules"
                    ></v-select>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon :disabled="view" small @click="removeFundCharge(item, currentUnitTrust.charges)">mdi-close</v-icon>
                  </template>

                </v-data-table>
              </v-card>

              <v-checkbox hide-details :readonly="view" class="pt-3" light v-model="currentUnitTrust.LoyalityParticipant" label="Fund activated for loyalty participation?"></v-checkbox>

              <v-row class="mt-7">
                <v-col class="py-0">
                  <v-select
                    outlined dense :readonly="view"
                    v-model="currentUnitTrust.MinInvestPeriod"
                    :items="InvestmentPeriods"
                    item-text="PeriodName"
                    item-value="PeriodID"
                    placeholder="----"
                    :rules="TextFieldRules"
                  ></v-select>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.MinInvestAmount"
                    label="Min. Investment Amount"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-text-field
                v-model="currentUnitTrust.RedemptionPeriod"
                label="Redemption Period (days)"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs" :readonly="view"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="mx-4 my-0"></v-divider>
          <span class="grey--text subtitle-1 font-weight-normal ml-4 mt-0">Unit Price Details</span>

          <v-row class="ml-1 mr-1 mt-3">
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.PurchaseUnitPrice"
                :items="PriceQuotations"
                label="Purchase Unit Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.FundPriceCalculation"
                :items="PriceCalculations"
                label="Price Calculation"
                item-text="Value"
                item-value="ID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-text-field
                v-model="currentUnitTrust.FundParValue"
                label="Fund Par Value"
                placeholder="----"
                dense outlined color="#2A353D"
                :rules="TextFieldRules"
                v-bind="attrs" :readonly="view"
                v-on="on"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.SellingUnitPrice"
                :items="PriceQuotations"
                label="Selling Unit Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.PrePostPriced"
                :items="Pricing"
                label="Pre/Post Priced"
                item-text="Value"
                item-value="ID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
            <v-col class="py-0">
              <v-select
                outlined dense :readonly="view"
                v-model="currentUnitTrust.ValuePrice"
                :items="PriceQuotations"
                label="Unit Holder Value Determining Price"
                item-text="PriceQuotationName"
                item-value="PriceQuotationID"
                placeholder="----"
                :rules="TextFieldRules"
              ></v-select>
            </v-col>
          </v-row>

          <v-row class="ml-1 mr-1">
            <v-col class="py-0">
              <v-divider class="my-0"></v-divider>
              <span class="grey--text subtitle-1 font-weight-normal mt-0">Spread Calculation</span>

              <v-row class="mt-6">
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.BidSpread"
                    label="Bid (%)"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
                <v-col class="py-0">
                  <v-text-field
                    v-model="currentUnitTrust.OfferSpread"
                    label="Offer (%)"
                    placeholder="----"
                    dense outlined color="#2A353D"
                    :rules="TextFieldRules"
                    v-bind="attrs" :readonly="view"
                    v-on="on"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="py-0">
              <v-textarea
                outlined
                v-model="currentUnitTrust.Notes"
                name="input-7-4"
                label="Notes"
                rows="3" :readonly="view"
                value="....................."
              ></v-textarea>

              <div class="text-right mb-4 mt-4">
                <v-btn class="white--text" small color="#2A353D" @click="view = false, closeEdit()">close</v-btn>
                <v-btn class="white--text ml-4" v-if="!view" small color="#2A353D" :disabled="!valid || loading == true" @click="update()">
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  save
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-form>

    <!-- ********************************************************************************************TABLE**************************************************************************************************
    ***************************************************************************************************************************************************************************************************** -->

      <v-data-table
        disable-pagination
        hide-default-footer
        :height="520"
        :headers="headers"
        :fixed-header="true"
        :items="confirmedUnitTrusts ? UnitTrusts : UnitTrusts.filter(a => a.CheckerID === 0)"
        :search="search" v-if="!create &&  !edit"
        sort-by="MakeDate"
        sort-desc
        class="elevation-12 mt-2"
        @current-items="getFiltered"
      >

        <template v-slot:top >
          <v-dialog persistent v-model="dialog" max-width="500px">
            <v-card>
              <v-card-title>
                <span class="subtitle-1 grey--text">Choose a reason for this rejection</span>
              </v-card-title>

              <v-card-text>
                <v-select
                  filled dense
                  v-model="RejectionStatus"
                  :items="allRejectionReasons.filter(a => a.CheckerID != 0 && a.RejectionID == 0)"
                  item-text="RejectionReasonDescription"
                  item-value="RejectionReasonID"
                  label="Rejection Reasons"
                ></v-select>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <div class="text-right mb-4">
                  <v-btn class="white--text mr-3" small color="#2A353D" @click="close()">cancel</v-btn>
                  <v-btn class="white--text mr-3" small color="#2A353D" v-if="RejectionStatus !== 0" @click="updateStatus('', false); close()">
                    <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    ok
                  </v-btn>
                </div>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog persistent v-model="reverseDialog" max-width="500px">
            <v-form flat ref="form" v-model="valid" lazy-validation>
              <v-card>
                <v-card-title>
                  <span class="grey--text text-center">Deal Reversal</span>
                </v-card-title>

                <v-card-text>
                  <span class="subtitle-1">{{reversal_description}}</span>

                  <v-textarea
                    class="mt-3"
                    label="Reversal Reason"
                    v-model="ReversalReason"
                    outlined rows="6"
                    row-height="15"
                    :rules="TextFieldRules"
                    placeholder="----"
                  ></v-textarea>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <div class="text-right mb-4">
                    <v-btn class="white--text mr-3" small color="#2A353D" @click="reverseDialog = false">cancel</v-btn>
                    <v-btn class="white--text mr-3" small color="#2A353D" :disabled="!valid" @click="ReverseDeal()">
                      <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                      submit
                    </v-btn>
                  </div>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>

          <v-container row>
            <v-text-field
              class="ml-3"
              hide-details
              outlined
              placeholder="search..."
              v-model="search"
              append-icon="mdi-magnify"
              dense
            ></v-text-field>

            <v-spacer></v-spacer>

            <v-btn v-if="showCreateBtn == true" v-show="confirmedUnitTrusts" @click="overlay = true; showCreate(); closeEdit()" outlined small color="#2A353D" class="ml-2">
              Create New<v-icon small>mdi-plus</v-icon>
            </v-btn>
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" v-show="confirmedUnitTrusts" outlined small color="#2A353D" class="ml-2">
                EXPORT<v-icon class="ml-1" small>mdi-exit-to-app</v-icon>
              </v-btn>
              </template>
              <v-list dense>
              <v-list-item class="ma-0 pa-0">
                <v-btn @click="generatePDF(false)" text small color="#2A353D">
                  <v-icon class="mr-1" small>mdi-file-pdf-box</v-icon>TO PDF
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <download-excel
                    :data   = "CurrentDataset"
                    type    = "xls"
                    name    = "Equity Purchases.xls">

                    <v-icon class="mr-1" small>mdi-microsoft-excel</v-icon>TO EXCEL
                  </download-excel>
                </v-btn>
              </v-list-item>
              <v-list-item class="ma-0 pa-0">
                <v-btn text small color="#2A353D">
                  <download-excel
                    :data   = "CurrentDataset"
                    type    = "csv"
                    name    = "Equity Purchases.csv">

                    <v-icon class="mr-1" small>mdi-file-document-outline</v-icon>TO CSV
                  </download-excel>
                </v-btn>
              </v-list-item>
              </v-list>
            </v-menu>
            <v-btn @click="generatePDF(true)" v-show="confirmedUnitTrusts" outlined small color="#2A353D" class="ml-2" v-on="on">
              PRINT<v-icon class="ml-1" small>mdi-printer</v-icon>
            </v-btn>
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on, attrs }">
              <v-btn v-on="on" v-bind="attrs" outlined small color="#2A353D" class="ml-2">
                CURRENCY<v-icon class="ml-1">mdi-cash-check</v-icon>
              </v-btn>
              </template>
              <v-list dense>
              <v-list-item v-for="Currency in allCurrencies.filter(a => a.CheckerID != 0 && a.RejectionID == 0)" :key="Currency.CurrencyID" @click="mapCurrency(Currency); getFundCharges()">

              <v-list-item-title>
                {{ Currency.CurrencyName }}
              </v-list-item-title>

              </v-list-item>
              </v-list>
            </v-menu>
            <v-btn v-show="!confirmedUnitTrusts" @click="confirmedUnitTrusts = true" outlined small color="#2A353D" class="ml-2" v-on="on">
              ALL RECORDS<v-icon class="ml-1">mdi-playlist-check</v-icon>
            </v-btn>
          </v-container>
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip outlined small color="error" v-if="item.RejectionID !== 0">rejected</v-chip>
          <v-chip outlined small color="warning" v-if="item.CheckerID == 0">pending</v-chip>
          <v-chip outlined dark small color="#A6D879" v-if="item.CheckerID !== 0 && item.RejectionID == 0">confirmed</v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-tooltip v-if="!confirmedUnitTrusts && item.CheckerID == 0" top>

          </v-tooltip>
          <v-tooltip v-if="!confirmedUnitTrusts && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="updateStatus(item, true)"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              confirm<v-icon class="ml-1" color="#2A353D">mdi-check-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>confirm</span>
          </v-tooltip>
          <v-tooltip v-if="!confirmedUnitTrusts && item.CheckerID == 0" top>
            <template v-slot:activator="{ on }">
            <v-btn
              small @click="reject(); setActiveUnitTrust(item, index)"
              outlined :disabled="showConfirmBtn == false || item.MakerID == currentUser.SecurityUserID || item.LastUserID == currentUser.SecurityUserID"
              v-on="on"
              color="#2A353D" class="mr-3"
            >
              reject<v-icon class="ml-1" color="#2A353D">mdi-close-circle-outline</v-icon>
            </v-btn>
            </template>
            <span>reject</span>
          </v-tooltip>
          <v-btn
            v-show="confirmedUnitTrusts"
            small outlined v-if="item.CheckerID == 0? item.MakerID == currentUser.SecurityUserID : showEditBtn == true"
            @click="TotalValue = item.Quantity * item.UnitPrice; setActiveUnitTrust(item, index); showEdit(); closeCreate()"
            color="#2A353D" class="mr-3"
          >
            <span>edit</span>
          </v-btn>
          <v-btn
            small outlined
            @click="view = true; setActiveUnitTrust(item, index); showEdit(); closeCreate()"
            color="#2A353D" class="mr-3"
          >
            <span>view</span>
          </v-btn>
          <v-tooltip v-if="confirmedUnitTrusts" top>
            <template v-slot:activator="{ on }">
              <v-icon
                v-on="on"
                :disabled="showReverseBtn == true && item.CheckerID == 0 ? false : true"
                color="#2A353D" @click="setActiveUnitTrust(item, index); initReversal(item)"
              >
              mdi-backup-restore
              </v-icon>
            </template>
            <span>reverse</span>
          </v-tooltip>
        </template>

        <!-- <template v-slot:item.ValueDate="{ item }">
          {{ item.ValueDate | moment("DD MMM YYYY") }}
        </template>  -->

        <!-- <template v-slot:item.MakeDate="{ item }">
          {{ item.MakeDate | moment("DD MMMM YYYY") }}
        </template> -->

      </v-data-table>
    </v-container>
    </template>

    <script>
    import {mapGetters, mapActions} from "vuex";
    import UserService from '../services/user.service';
    import administrationService from '../services/administration.service';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable'

    export default {
      name: 'unit_trust_defination',

      data () {
        return {
          confirmedUnitTrusts: true,
          edit: false,
          create:false,
          view: false,
          message: '',
          menu: false,
          menu_1: false,
          menu_2: false,
          dialog: false,
          reverseDialog: false,
          ReversalReason: '',
          reversal_description: '',
          overlay: false,
          ListedCounters: true,
          permitted: null,
          permitted_dialog: true,
          loading: false,
          search: '',
          valid: true,
          content: '',
          currentAllocation: null,
          allocationIndex: -1,
          currentUnitTrust: null,
          currentIndex: -1,
          CurrentDataset: [],
          headers: [
            {
              text: 'Short Name',
              align: 'start',
              sortable: true,
              value: 'ShortName'
            },
            { text: 'Description', value: 'Description', sortable: true },
            // { text: 'Value Date', value: 'ValueDate', sortable: true },
            // { text: 'Deposit Method', value: 'DepositMethodID', sortable: true },
            // { text: 'Date Created', value: 'MakeDate', sortable: true },
            { text: 'Status', value: 'status', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          TextFieldRules: [
            v => (!!v || v == 0) || 'field is required',
          ],
          CreateDateRules: [
            v => !!v || 'field is required',
            v => (v <= this.currentSystemDate.DayDate) || 'Date must not exceed Purchase Date'
          ],
          EditDateRules: [
            v => !!v || 'field is required',
            v => (v <= this.currentUnitTrust.PurchaseDate) || 'Date must not exceed Purchase Date'
          ],
          // AllocatedValueRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
          // ],
          // AllocatedUnitsRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.UnitTrust.def.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
          // ],
          // EditAllocatedValueRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.TotalValue).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2})) || 'should match Deal Value',
          // ],
          // EditAllocatedUnitsRules: [
          //   v => !!v || 'field is required',
          //   v => (!!v && v == Number(this.currentUnitTrust.Quantity).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0})) || 'should match Deal Quantity',
          // ],
          view_asset_classes_headers: [
            { text: 'Asset Class', value: 'AssetTypeId', sortable: false },
            { text: 'Narration', value: 'Narration', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          asset_classes_headers: [
            { text: 'Asset Class', value: 'AssetTypeId', sortable: false },
            { text: 'Narration', value: 'Narration', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          AssetClasses: [],
          view_charges_headers: [
            { text: 'Transaction Charge Name', value: 'TransactionChargeId', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          charges_headers: [
            { text: 'Transaction Charge Name', value: 'TransactionChargeId', sortable: false },
            { value: 'actions', sortable: false, align: 'end' },
          ],
          FundCharges: [],
          balances: {},
          CurrencyId: 0,
          UnderlyingPortfolios: [],
          Classes: [],
          Charges: [],
          InvestmentPeriods: [],
          PriceQuotations: [],
          PriceCalculations: [
            {ID: 0, Value: 'Manual'},
            {ID: 1, Value: 'Automatic'}
          ],
          Pricing: [
            {ID: 0, Value: 'Pre-Priced'},
            {ID: 1, Value: 'Post-Priced'}
          ],
          UnderlyingAssets: [],
          RejectionStatus: 0,
          UnitTrust: {
            def: {},
            AssetClasses: [],
            FundCharges: []
          },
          errors: [],
          BlockingViolation: null,
          BNerrors: [],
        }
      },

      computed: {
        ...mapGetters([
          "allUnitTrustFunds",
          "allApplicationDefaults",
          "allCurrencies",
          "allAssetTypes",
          "allRejectionReasons",
          "allUsers",
          "currentSystemDate",
          "allConfirmationSettings"
        ]),

        currentUser() {
          return this.$store.state.auth.user;
        },
        // UnitTrusts() {
        //   return this.allUnitTrustFunds.filter(a => a.CurrencyId == this.CurrencyId);
        // },
        UnitTrusts() {
          return this.allUnitTrustFunds;
        },
        Currency() {
          return this.allCurrencies.filter(a => a.CurrencyID == this.CurrencyId && a.CheckerID != 0 && a.RejectionID == 0);
        },
        showEditBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowEdit)) == 1){
            return true
          }
        }
        return false;
        },

        showCreateBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowCreate)) == 1){
            return true
          }
        }
        return false;
        },

        showConfirmBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowConfirm)) == 1){
            return true
          }
        }
        return false;
        },

        showReverseBtn() {
        for (let i = 0; i < this.currentUser.roles.length; i++) {
          if (this.currentUser.roles[i].role_name.map(r => r.role_permission.filter(r => r.FunctionID === 323).map(r => r.AllowReversal)) == 1){
            return true
          }
        }
        return false;
        },

        CheckerID(){
          if(this.allConfirmationSettings.filter(a => a.FunctionID == 323).map(a => a.Status)[0] == false){
            return this.currentUser.SecurityUserID
          } else {
            return 0
          }
        }
      },

      watch: {

      },

      created () {
        this.CurrencyId = this.allApplicationDefaults[0].CurrencyID;
        this.getUnderlyingPortfolios();
        this.getFundClasses();
        this.getFundCharges();
        this.getInvestmentPeriods();
        this.getPriceQuotation();
        this.getUnderlyingAssets()
      },

      methods: {
        ...mapActions([
          "createUnitTrustFund",
          "updateUnitTrustFund",
          "updateUnitTrustFundStatus"
        ]),

         async createNew() {
          this.message = '';

          await this.validate()

          if (this.valid == true) {
            this.loading = true;
            this.UnitTrust.def.MakerID = this.currentUser.SecurityUserID,
            this.UnitTrust.def.CheckerID = this.CheckerID,
            this.UnitTrust.def.CurrencyId = this.CurrencyId,
            this.UnitTrust.def.LastUserID = this.currentUser.SecurityUserID,

            this.createUnitTrustFund(this.UnitTrust)
            .then(response =>{
              this.$socket.client.emit('socketreq', {
                commit: 'newUnitTrustFund',
                data: response.data
              });
              this.message = response.data.message
              this.loading = false;
              this.closeCreate()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })
          }
        },

        async update() {
          this.message = '';

          await this.validate()

          if (this.valid == true) {
            this.loading = true;
            this.currentUnitTrust.MakerID = this.currentUser.SecurityUserID,
            this.currentUnitTrust.LastUserID = this.currentUser.SecurityUserID,
            this.currentUnitTrust.CheckerID = 0,
            this.currentUnitTrust.CheckDate = null,
            this.currentUnitTrust.MakeDate = new Date(),
            this.currentUnitTrust.RejectionID = this.RejectionStatus,

            this.updateUnitTrustFund(this.currentUnitTrust)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'updUnitTrustFund',
                data: this.currentUnitTrust
              });

              this.message = response.data.message
              this.loading = false;
              this.closeEdit()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })
          }
        },

        updateStatus(item, status) {
          this.message = '';
          this.loading = true;

          if(status == true){
            item.CheckerID = this.currentUser.SecurityUserID,
            item.LastUserID = this.currentUser.SecurityUserID,
            item.CheckDate = new Date(),
            item.updatedAt = new Date(),
            item.RejectionID = this.RejectionStatus,
            item.IsConfirmation = status,

            this.updateUnitTrustFundStatus(item)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'updUnitTrustFund',
                data: item
              });

              this.message = response.data.message
              this.loading = false;
              this.closeEdit()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })
          } else {
            this.currentUnitTrust.CheckerID = this.currentUser.SecurityUserID,
            this.currentUnitTrust.LastUserID = this.currentUser.SecurityUserID,
            this.currentUnitTrust.CheckDate = new Date(),
            this.currentUnitTrust.updatedAt = new Date(),
            this.currentUnitTrust.RejectionID = this.RejectionStatus,
            this.currentUnitTrust.IsConfirmation = status,

            this.updateUnitTrustFundStatus(this.currentUnitTrust)
            .then(response => {
              this.$socket.client.emit('socketreq', {
                commit: 'updUnitTrustFund',
                data: this.currentUnitTrust
              });

              this.message = response.data.message
              this.loading = false;
              this.closeEdit()
            },
            error => {
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
              this.loading = false;
            })
          }
        },

        getUnderlyingPortfolios() {
          this.message = '';
          administrationService.getUnderlyingPortfolios(0,'blank')
          .then(response => {
            this.UnderlyingPortfolios = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        getFundClasses() {
          this.message = '';
          administrationService.getFundClasses(0,'blank')
          .then(response => {
            this.Classes = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        getFundCharges() {
          this.message = '';
          administrationService.getFundCharges(2, this.CurrencyId)
          .then(response => {
            this.Charges = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        getInvestmentPeriods() {
          this.message = '';
          administrationService.getInvestmentPeriods()
          .then(response => {
            this.InvestmentPeriods = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        getPriceQuotation() {
          this.message = '';
          administrationService.getPriceQuotation()
          .then(response => {
            this.PriceQuotations = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        getUnderlyingAssets() {
          this.message = '';
          administrationService.getUnderlyingAssets()
          .then(response => {
            this.UnderlyingAssets = response.data
          },
          error => {
          this.message =
            (error.response && error.response.data.message) ||
            error.message ||
            error.toString();
          })
        },

        generatePDF(IsPrint) {
          const addFooters = doc => {
            const pageCount = doc.internal.getNumberOfPages()

            for (var i = 1; i <= pageCount; i++) {
              doc.setPage(i)
              // text is placed using x, y coordinates
              doc.setFontSize(10).text("Unit Trust Funds", 0.5, 0.5);
              // create a line under heading
              doc.setLineWidth(0.01).line(0.5, 0.6, 8.0, 0.6);
              doc.setLineWidth(0.01).line(0.5, 0.8, 8.0, 0.8);
              doc.setFontSize(6).text('Page ' + String(i) + ' of ' + String(pageCount), 4.3, 10.7, {
                align: 'center'
              })
            }
          }

          let doc = new jsPDF({
            orientation: "potrait",
            unit: "in",
            format: "letter"
          });

          doc.setFont('helvetica');
          doc.setFontSize(5);
          doc.autoTable({
            body: this.CurrentDataset,
            margin: { left: 0.5, top: 0.6 },
            styles: {overflow: 'linebreak',
                    fontSize: 6},
            showHeader: 'everyPage',
            theme: 'plain'
          });
          addFooters(doc);
          if(IsPrint == true){
            doc.output('dataurlnewwindow');
          } else{
            doc.save('Unit Trust Funds.pdf')
          }
        },

        mapCurrency(currency) {
          return this.CurrencyId = currency.CurrencyID
        },

        NewAssetClass(item) {
          item.push(
            {
              AssetTypeId: null,
              Narration: ''
            }
          )
        },

        removeAssetClass(item, parent) {
          const index = parent.findIndex(p => p.AssetTypeId === item.AssetTypeId);
          parent.splice(index, 1)
        },

        NewFundCharge(item) {
          item.push(
            {
              TransactionChargeId: null
            }
          )
        },

        removeFundCharge(item, parent) {
          const index = parent.findIndex(p => p.TransactionChargeId === item.TransactionChargeId);
          parent.splice(index, 1)
        },

        getFiltered(current){
          this.CurrentDataset = current;
        },

        unconfirmed() {
          this.confirmedUnitTrusts = false
        },

        showEdit () {
          this.edit = true
        },

        closeEdit() {
          this.currentUnitTrust = null,
          this.AssetClasses = [],
          this.FundCharges = [],
          this.edit = false
        },

        showCreate () {
          this.create = true;
        },

        closeCreate() {
          this.UnitTrust.def = {},
          this.AssetClasses = [],
          this.FundCharges = [],
          this.create = false
        },

        reject () {
          this.dialog = true
        },

        close () {
          this.dialog = false
          this.RejectionStatus = 0
        },

        showMessage(){
          if(this.message){
            return true
          } else {
            return false
          }
        },

        validate () {
          this.$refs.form.validate()
          return this.valid
        },

        reset () {
          this.$refs.form.reset()
        },

        async EditAllocation (item) {
          if(this.view != true){
            for (let i = 0; i < item.allocations.length; i++) {
              await this.getCurrentAccountBalance(item.allocations[i])
            }
            return item
          } else {
            return item
          }
        },

        async setActiveUnitTrust (item, index) {
          this.currentUnitTrust = item
          this.currentIndex = index
        },

        async setActiveAllocation (item, index) {
          this.currentAllocation = item
          this.allocationIndex = index
        },
      },

      mounted () {
        UserService.isUnitTrust().then(
          () => {
            this.permitted = true;
            this.message = '';
          },
          error => {
            this.permitted = false;
            this.message =
              (error.response && error.response.data.message) ||
              error.message ||
              error.toString();
          }
        );
        this.$root.$on("unconfirmedUnitTrustFunds", () => {
          this.unconfirmed();
        });
      }
    }
    </script>

    <style scoped>
    .list {
      text-align: left;
      max-width: 750px;
      margin: auto;
    }

    .edit {
      background-color: #DBEFFA;
    }

    .section {
      background-color: rgb(242, 242, 242);
    }

    .v-btn {
      outline: none
    }

    /* .v-select__selections input {
      display: none;
    } */

    .Account {
      width: 150px;
    }

    .my-allocations-table{
      table-layout : fixed;
    }

    .table-text-field{
      width: 230px;
    }

    .headline {
      color:white
    }
    </style>
